import { fetchEndpointData } from '@/utils/fetch.client';

export interface ProviderRepo {
  id: string;
  name: string;
  full_name: string;
  description: string | null;
  language: string | null;
  stargazers_count: number;
  updated_at: string;
  private: boolean;
  html_url: string;
  default_branch: string | null;
  provider: string;
}

interface ListProviderReposResponse {
  repositories: Omit<ProviderRepo, 'provider'>[];
  provider: string;
}

export async function fetchProviderRepos(query?: string, signal?: AbortSignal): Promise<ProviderRepo[]> {
  const url = query
    ? `/api/v1/integrations/repositories?q=${encodeURIComponent(query)}`
    : '/api/v1/integrations/repositories';
  const data = await fetchEndpointData<ListProviderReposResponse>(url, { signal });
  return data.repositories.map((repo) => ({ ...repo, provider: data.provider }));
}
